import React from 'react'
import {Link} from "react-router-dom"
import "./Page.css"

export default function Home() {
  return (
    <div>

    <body background={require('./images/a2.jpg')} >

    <table align="center" width="900">
          
    <tr>

      <td width="200" align="center"> <Link to="/Home"> <h3><font face="Trebuchet" color="white" size="4">Home</font></h3></Link></td>
     
      <td width="200" align="center"> <Link to="/Products"><h3><font face="Trebuchet" color="white" size="4">Products</font></h3></Link></td>
     
      <td width="200" align="center"> <Link to="/Clients"><h3><font face="Trebuchet" color="white" size="4">Clients</font></h3></Link></td> 
      
      <td width="200" align="center"> <Link to="/Contact"><h3><font face="Trebuchet" color="white" size="4">Contact us</font></h3></Link></td>  

    </tr>

    </table>

       
     
       
      <table align="center">

      <tr>

         <td width="300"  height="250"> <img  alt="aaa" width="300"  height="200" src={require('./images/yellow.jpeg')}/>     </td>

         <td  align="center" width="450"  height="200"> 
         
         <h3> <i>
                 <font face="Trebuchet" size="6" color="white" >A description about your business</font>
         </i></h3>
       
       <h4>(Product & services offered to customers )</h4>
       
       <h4>
             
                  
       
       </h4>
       
       
       
                  <font face="verdana"  size="3" color="white"><b> Hotline :Your telephone </b></font>
       
          </td>  

          <td width="300"  height="250"> <img  alt="aaa" width="300"  height="200" src={require('./images/anthurium.jpeg')}/>     </td>
      </tr>


      </table>
     



 


<table align="center" cellspacing="5"  cellpadding="5" >

<tr>

<td align="center" width="350"  height="20"> <font color="white" face="Times New Roman" size="3">Product image [1]</font>  </td>
<td align="center" width="350"  height="20"><font color="white" face="Times New Roman" size="3">Product image [2]</font>  </td>
<td align="center" width="350"  height="20"> <font color="white" face="Times New Roman" size="3">Product image [3]</font>  </td>

</tr>

</table>
  
<table align="center" cellspacing="5"  cellpadding="5" >

<tr>


<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/sunflower.jpeg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/rambutan.jpeg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/orchid.jpeg')}/> </td>

</tr>

</table>

<h4 align="center"> <font size="3" color="white" face="Times New Roman">Developed & Updated on 2024-02-11 by Priyantha Wanninayake  Email : kstpromotions@gmail.com  </font></h4>

</body>

    </div>
     
     

  )
}